import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum SalesCaseStatusId {
  OPEN = 'open',
  WON = 'won',
  LOST = 'lost',
  DELETED = 'deleted',
}

export class SalesCaseStatus extends Codebook<SalesCaseStatusId> {
  static readonly OPEN = new SalesCaseStatus(
    SalesCaseStatusId.OPEN,
    () => $t('Open'),
    'plus',
    undefined,
  )

  static readonly WON = new SalesCaseStatus(
    SalesCaseStatusId.WON,
    () => $t('Won'),
    'stars',
    Color.POSITIVE_TRANSPARENT,
  )

  static readonly LOST = new SalesCaseStatus(
    SalesCaseStatusId.LOST,
    () => $t('Lost'),
    'xmark',
    Color.NEGATIVE_TRANSPARENT,
  )
  static readonly DELETED = new SalesCaseStatus(
    SalesCaseStatusId.DELETED,
    () => $t('Deleted'),
    'trash',
    undefined,
  )

  private constructor(
    id: SalesCaseStatusId,
    public readonly name: () => string,
    public readonly icon: string,
    public readonly color: Color.POSITIVE_TRANSPARENT | Color.NEGATIVE_TRANSPARENT | undefined,
  ) {
    super(id)
  }
}
